jQuery('.contact-banner-hotspot svg.icon').click(function() {
    jQuery('.contact-banner-hotspot .overlay').fadeToggle().css('display', 'flex');

    switch (jQuery('.contact-banner-background-container').attr('data-status')) {
        case 'off':
            jQuery('.contact-banner-background-container').attr('data-status', 'on');
            jQuery('.contact-banner-background-container .off').fadeOut("slow");
            jQuery('.contact-banner-background-container .on').fadeIn();
            break;
        case 'on':
            jQuery('.contact-banner-background-container').attr('data-status', 'off');
            jQuery('.contact-banner-background-container .on').fadeOut("slow");
            jQuery('.contact-banner-background-container .off').fadeIn();
            break;
    }
});

jQuery('#contactBannerLeaveMessage').click(function(e) {
    e.preventDefault();
    var offset = jQuery('#message').offset();
    jQuery('html, body').animate({
        scrollTop: offset.top - 150
    }, 200);
});

jQuery('#contactBannerShowroom').click(function(e) {
    e.preventDefault();
    var offset = jQuery('#showroom').offset();
    jQuery('html, body').animate({
        scrollTop: offset.top - 150
    }, 200);
});

jQuery('.contact-banner .book-tour').click(function(e) {
    e.preventDefault();
    var offset = jQuery('#message').offset();
    jQuery('html, body').animate({
        scrollTop: offset.top - 150
    }, 200);
});